import Navbar from '../Navbar/Navbar';
import { useState, useEffect } from 'react';
import CardData6 from '../../data/CardData6';
import Card from '../Card';
import { Link } from 'react-router-dom';
import TheCarousel from '../TheCarousel';

// Función para barajar el array
const shuffleArray = (array) => {
  return array
    .map((item) => ({ item, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ item }) => item);
};

function ClassicRock() {
  const [searchQuery, setSearchQuery] = useState('');
  const [shuffledData, setShuffledData] = useState([]);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Generar IDs y barajar solo una vez al montar
    const dataWithIds = CardData6.map((item, index) => ({
      ...item,
      id: `${item.title}-${index}`,
    }));

    setShuffledData(shuffleArray(dataWithIds));

    // Detectar si es mobile
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    handleResize(); // inicial
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const filteredData = shuffledData.filter((item) =>
    item.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div>
      <Navbar />
      <h1 className="title2">Rock Clásico</h1>

      {/* Barra de búsqueda */}
      <div className="search-bar">
        <input
          className="searchbar"
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Busca por Nombre del Artista Aquí...🔍︎"
        />
      </div>

      {/* Botón de categorías */}
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Link to="/categories">
          <button
            style={{
              fontSize: '1rem',
              width: '200px',
              fontFamily: 'Henny Penny',
              background: 'goldenrod',
              color: 'black',
              borderRadius: '10px',
              marginTop: '20px',
            }}
          >
            Escoge el Tipo de Música
          </button>
        </Link>
      </div>

      <h1 className="slidertext">←← Desliza para Navegar →→</h1>

      {/* Vista condicional */}
      {isMobile ? (
        <section className="cards-list">
          {filteredData.map((item) => (
            <Card key={item.id} item={item} />
          ))}
        </section>
      ) : (
        <TheCarousel items={filteredData} />
      )}
    </div>
  );
}

export default ClassicRock;